import ProductRowList from "@components/commerce/product/list/product-row-list/ProductRowList";
import { styles } from "./StaticBagListStyles";
import type { LineItem } from "@graphql/generated/types";
import type { FC, ReactNode } from "react";
import { Box } from "@ecco/ui/box";
import { H } from "@ecco/ui/a11y-heading";

interface IStaticBagListProps {
    productsList: LineItem[];
    locale: string;
    totalQuantity: number;
    children?: ReactNode;
    headerText?: string;
}
export const staticSmallShoppingBag = "static-bag-list";
export const headerTextId = "header-text";

export const StaticBagList: FC<IStaticBagListProps> = ({
    productsList,
    totalQuantity,
    locale,
    headerText,
    children,
}) => {
    return (
        <Box sx={styles.container}>
            <Box
                sx={{ ...styles.bagContainer, paddingBottom: !totalQuantity ? 6 : 0 }}
                data-testid={staticSmallShoppingBag}
            >
                <Box>
                    <H
                        as="h5"
                        fontSize={["mobileBodyTextSmall", "desktopBodyTextSmall"]}
                        fontWeight="bold"
                        textTransform={"uppercase"}
                        data-testid={headerTextId}
                        mb={6}
                    >
                        {headerText} ({totalQuantity || 0})
                    </H>
                </Box>
                <ProductRowList items={productsList} locale={locale} />
            </Box>
            {children}
        </Box>
    );
};
